<template>
  <div>
    <div id="_div" class="w-100 px-5 py-4">

      <div id="Titulo_div">
        <h1>Registro de Denuncia</h1>
        <h2 v-show="consecutivo">{{consecutivo}}</h2>
      </div>
      <div style="display: flex">
        
        <div class="col-12 padding-div-low">
          <div class="row tab">
            <button class="tablinks active" @click="cambiarPestana($event,0)">Datos Generales</button>
            <button class="tablinks" @click="cambiarPestana($event,1)" v-if="denunciaId">Acuerdos</button>
            <button class="tablinks" @click="cambiarPestana($event,2)" v-if="denunciaId">Datos Finales</button>
          </div>
          <div class="area">

            <div class="row new-row">
              <div class="col-4">
                <h2>{{datosPestana.titulo}}</h2>
              </div>
            </div>
            <hr />
            <div v-show="datosPestana.pestanaId === 0">
              <DatosGenerales v-on:valorParaElPadre="obtenerDenunciaId" :prop_denuncia="denuncia" :key="denunciaId"></DatosGenerales>
            </div>
            <div v-show="datosPestana.pestanaId === 1">
              <Acuerdos :prop_denunciaId ="denunciaId" :key="denunciaId" :prop_acuerdos="denuncia.acuerdos"></Acuerdos>
            </div>
            <div v-show="datosPestana.pestanaId === 2">
              <DatosFinales :prop_denunciaId ="denunciaId" :key="denunciaId" :prop_denuncia="denuncia"></DatosFinales>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import catalogos from '@/../static/js/catalogos'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import store from '@/store/index'
  import DatosGenerales from '@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/DatosGenerales.vue'
  import DatosFinales from '@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/DatosFinales.vue'
  import Acuerdos from '@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/Acuerdos.vue'
  import { Denuncia } from "@/components/SIFA/Comun/Modelos/Denuncia.js"
  export default {
    data() {
      return {
        denuncia: new Denuncia(),
        datosPestana: {titulo: "Datos Generales", pestanaId: 0},
        denunciaId: null,
        consecutivo: ""
        
      }
    },
    props: {
      prop_denunciaId: Number
    },
    components: {
      DatosGenerales,
      DatosFinales,
      Acuerdos
    },
    methods: {
      obtenerDatosDenunciaFormulario() {
      //Retorna una lista de citas 'Aceptadas'
      var peticion = {
        denunciaId: this.prop_denunciaId,
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.ObtenerDatosDenunciaFormulario,
          peticion /*, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)*/
        )
        .then(response => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            this.denuncia = new Denuncia();
            this.denuncia.constructorObjeto(response.data.denuncia);
            this.denunciaId = this.prop_denunciaId;
            this.consecutivo = this.denuncia.consecutivo;
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
      cambiarPestana(event, pestanaId) {
        this.datosPestana.titulo = event.target.innerHTML;
        this.datosPestana.pestanaId = pestanaId;
        const pestanas = document.querySelectorAll('.tab button');
        pestanas.forEach(pestana => pestana.classList.remove('active'));
        event.target.classList.add("active");
      },
      obtenerDenunciaId(datos){
        catalogos;
        this.denunciaId = parseInt(datos[0])
        this.consecutivo = datos[1]
      }
      
    }, mounted: function mounted() {
      if(this.prop_denunciaId){        
        this.obtenerDatosDenunciaFormulario();
      }
      
    },
    computed: {
      datosGeneralesNoValidos() {
        return !this.faltaAdministrativa.fechaDeRecepcion || !this.faltaAdministrativa.denunciante || !this.faltaAdministrativa.presuntoResponsable
                || !this.faltaAdministrativa.adscripcion || !this.faltaAdministrativa.actoReclamado
      }

    }
  }
</script>

<style scoped>
  span {
    font-weight: bold;
  }
  b {
    padding-right: 3px;
  }

  .new-row {
    margin-top: 20px;
  }

  .fas {
    cursor: pointer;
  }
  .tab {
    overflow: hidden;
    padding-left:15px;
  }

  /* Style the buttons inside the tab */
  .tab button {
    background-color: #45454c;
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
    font-size: 17px;
    color: whitesmoke;
    border-right: 1px solid #ccc;
    width: 20vw;
  }

  /* Change background color of buttons on hover */
  .tab button:hover {
    background-color: #ddd;
    color: #000;
  }

  /* Create an active/current tablink class */
  .tab button.active {
    background-color: #ccc;
    color: #000;
    font-weight:bolder;
  }
  .bigtextarea {
    height: 100px;
  }
</style>





// WEBPACK FOOTER //
// src/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/RegistroDeDenuncia.vue